const FIELDS = [
  ["subject_name", "Subject (the missing researcher)", "text"],
  ["nickname", "Family nickname", "text"],
  ["birth_year", "Birth year", "number"],
  ["father_name", "Father (played by the actor in the room)", "text"],
  ["father_role", "Father - who he is", "text"],
  ["mother_name", "Mother", "text"],
  ["mother_role", "Mother - who she is", "text"],
  ["home", "Where they lived", "text"],
  ["siblings", "Siblings", "text"],
  ["pets", "Pets", "text"],
  ["boat", "The family boat", "text"],
];

export const CaseFileEditor = ({ caseFile = {}, onChange }) => {
  const set = (k, type) => (e) => onChange({ ...caseFile, [k]: type === "number" ? Number(e.target.value) : e.target.value });
  return (
    <div data-testid="case-file-editor" className="grid gap-4">
      <div className="grid gap-3 sm:grid-cols-2">
        {FIELDS.map(([key, label, type]) => (
          <div key={key} className={key.endsWith("_role") ? "sm:col-span-2" : ""}>
            <label className="lab-label">{label}</label>
            <input data-testid={`case-${key}`} type={type} value={caseFile[key] ?? ""} onChange={set(key, type)} className={`lab-input mt-1 w-full ${type === "number" ? "font-mono" : ""}`} />
          </div>
        ))}
      </div>
      <div>
        <label className="lab-label">Anecdotes to weave in (the AI draws on these)</label>
        <textarea data-testid="case-anecdotes" rows={3} value={caseFile.anecdotes || ""} onChange={set("anecdotes", "text")} className="lab-input mt-1 w-full text-sm leading-relaxed" />
      </div>
      <p className="text-xs text-slate-500">Use {"{subject}"}, {"{nickname}"}, {"{father}"} and {"{home}"} in the narration and the hive's message - they fill in from here.</p>
    </div>
  );
};
